import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { MOBILE_NAVIGATION_HEIGHT } from '@pkg/components/MainNavigationMobile/styles';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

export const OuterWrapper = styled.div<{ $forceBottom?: boolean }>`
    position: fixed;
    right: 0;
    left: 0;
    border-radius: 30px 30px 0 0;
    overflow: hidden;
    z-index: 9999;

    ${({ $forceBottom }) =>
        $forceBottom
            ? css`
                  bottom: 0;
              `
            : css`
                  bottom: ${MOBILE_NAVIGATION_HEIGHT}px;
              `}
`;

export const InnerWrapper = styled(motion.div)<{ $customBackground?: string }>`
    width: 100%;

    ${({ $customBackground }) =>
        $customBackground
            ? css`
                  background: ${$customBackground};
              `
            : css`
                  background: #161616;
              `}
`;

export const DraggableBar = styled.div`
    height: 35px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        height: 4px;
        width: 40px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.25);
    }
`;

export const ItemEditMobileOverlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const ContentWrapper = styled(motion.div)`
    padding: 5px 10px 25px;
`;

export const StyledSwitch = styled.div`
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color ${({ theme }) => theme.transitions.speeds.fast}s ease-in-out;
`;

interface ImageSwitchWrapperProps {
    $active: boolean;
}

export const ImageSwitchWrapper = styled.div<ImageSwitchWrapperProps>`
    cursor: pointer;
    width: 64px;
    height: 32px;
    border-radius: 40px;
    background: rgba(247, 156, 156, 0.1);
    padding-left: 32px;
    transition: all ${({ theme }) => theme.transitions.speeds.fast}s ease-in-out;

    ${({ $active, theme }) =>
        $active &&
        css`
            padding-left: 0;
            ${StyledSwitch} {
                background: ${theme.colors.purple};
            }
        `}
`;

export const ActionsWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    padding: 25px 10px;
    position: relative;
    gap: 20px;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        width: 90%;
        height: 1px;
        background: ${({ theme }) => theme.shades.white[10]};
        margin: 0 auto;
    }
`;

export const StyledButton = styled(Button)`
    transition: all ${({ theme }) => theme.transitions.speeds.fast}s ease-in-out;
`;

interface DisplayAttributesWrapperProps {
    $confirmDelete: boolean;
}

export const DisplayAttributesWrapper = styled.div<DisplayAttributesWrapperProps>`
    transition: opacity ${({ theme }) => theme.transitions.speeds.fast}s
        ${({ theme }) => theme.transitions.easesCss.cubic};

    ${({ $confirmDelete }) =>
        $confirmDelete &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`;

export const NFTPreviewWrapper = styled.button`
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 100px;
    padding: 30px;
    appearance: none;
    background-color: transparent;
    border: 0 none;
`;
